import * as XLSX from 'xlsx';

export type ApplicantExportRow = {
  fullName: string;
  phoneNumber: string;
  leadId: string;
  leadSource: string;
  leadDate: string;
  assignedCounsellor: string;
  studentDetails: string;
  status: string;
  enrollmentType: string;
  amountQuotedWithGst: string;
  amountReceived: string;
  pendingAmount: string;
  documents: string;
  testOptedFor: string;
  assignedApplicationHandler: string;
  applicationTracking: string;
  universitiesAppliedTo: string;
  universitiesOffersReceived: string;
  universitiesOffersRejected: string;
  note: string;
};

type ExportColumnKey = keyof ApplicantExportRow;

const EXPORT_COLUMNS: { header: string; key: ExportColumnKey; width: number }[] = [
  { header: 'Student Name', key: 'fullName', width: 24 },
  { header: 'Contact Number', key: 'phoneNumber', width: 16 },
  { header: 'Student/Lead ID', key: 'leadId', width: 28 },
  { header: 'Lead Source', key: 'leadSource', width: 14 },
  { header: 'Lead Date', key: 'leadDate', width: 12 },
  { header: 'Assigned Counsellor', key: 'assignedCounsellor', width: 22 },
  { header: 'Student Details', key: 'studentDetails', width: 36 },
  { header: 'Status', key: 'status', width: 12 },
  { header: 'Enrollment Type', key: 'enrollmentType', width: 16 },
  { header: 'Amount Quoted + 18% GST', key: 'amountQuotedWithGst', width: 22 },
  { header: 'Amount Recieved', key: 'amountReceived', width: 16 },
  { header: 'Pending Amount', key: 'pendingAmount', width: 16 },
  { header: 'Documents', key: 'documents', width: 16 },
  { header: 'Test Opted For From Us', key: 'testOptedFor', width: 22 },
  { header: 'Assigned Application Handler', key: 'assignedApplicationHandler', width: 26 },
  { header: 'Application Tracking', key: 'applicationTracking', width: 28 },
  { header: 'Universities Applied to', key: 'universitiesAppliedTo', width: 28 },
  { header: 'Universities Offers Received From', key: 'universitiesOffersReceived', width: 32 },
  { header: 'Universities Offers Rejected From', key: 'universitiesOffersRejected', width: 32 },
  { header: 'Note', key: 'note', width: 36 },
];

const NUMERIC_COLUMNS = new Set<ExportColumnKey>([
  'amountQuotedWithGst',
  'amountReceived',
  'pendingAmount',
]);

function cellValue(row: ApplicantExportRow, key: ExportColumnKey): string | number {
  const raw = row[key] ?? '';
  if (NUMERIC_COLUMNS.has(key) && raw !== '') {
    const parsed = Number(raw);
    if (Number.isFinite(parsed)) return parsed;
  }
  return raw;
}

export function downloadApplicantsExcel(rows: ApplicantExportRow[], filename = 'enrolled-applicants.xlsx'): void {
  if (typeof document === 'undefined') return;

  const header = EXPORT_COLUMNS.map((column) => column.header);
  const data = rows.map((row) => EXPORT_COLUMNS.map((column) => cellValue(row, column.key)));

  const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);
  worksheet['!cols'] = EXPORT_COLUMNS.map((column) => ({ wch: column.width }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Enrolled Applicants');
  XLSX.writeFile(workbook, filename);
}
